<mat-card class="aboutCard">
    <mat-card-header>
        <mat-card-title>{{ title }}</mat-card-title>
    </mat-card-header>
    <mat-card-content>
        <div [innerHTML]="content" class="ck-editorControl"></div>
    </mat-card-content>
</mat-card>
